module.exports = __webpack_public_path__ + "static/img/project-management.f2745ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/project-management.png
// module id = S8qL
// module chunks = 1